import {interpolateRgbBasis} from "d3-interpolate";

export default function(scheme) {
  return interpolateRgbBasis(scheme[scheme.length - 1]);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale-chromatic/src/ramp.js
// module id = 14
// module chunks = 0